import { getField, updateField } from 'vuex-map-fields';
import apiAxios from '../../services/apiAxios';
import helpers from '../../mixins/helpers';
import moment from 'moment';

const state = {
    indicadores: [],
    /* Paginacion */
    paginaActual: 1,
    registrosPorPagina: 10,
    totalRegistros: 0,
    totalPaginas: 0,
    /* Filtro */
    fechaDesde: moment(new Date()).add(-3, 'years').format('YYYY-MM-DD'),
    fechaHasta: moment(new Date()).add(1, 'years').format('YYYY-MM-DD'),
};

const mutations = {
    updateField,

    'INICIALIZAR' (state) {
        state.indicadores = [];
    },
    'SET_INDICADORES' (state, indicadores) {
        state.indicadores = indicadores;
    },
    'SET_PAGINATION'(state, params) {
        state.paginaActual = params.paginaActual;
        state.registrosPorPagina = params.registrosPorPagina;
        state.totalRegistros = params.totalRegistros;
        state.totalPaginas = params.totalPaginas;
    },
};

const getters = {
    getField,
};

const actions = {
    getIndicadoresRentabilidadBruta ( { commit }, semestral ) {
        return new Promise((resolve, reject) => {
            commit('INICIALIZAR');

            let queryString = '?fechaDesde='+ moment(state.fechaDesde).format('YYYY-MM-DD')
            + '&fechaHasta='+ moment(state.fechaHasta).format('YYYY-MM-DD');
            
            if (state.paginaActual != 0) {
              queryString += '&pageSize=' + state.registrosPorPagina
                + '&pageNumber=' + state.paginaActual
            }
            
            let url = 'indicadores-rentabilidad';
            if ((/true/i).test(semestral)) {
                url += '/semestral';
            } else {
                url += '/anual';
            }

            apiAxios.get(url + queryString)
                .then(res => {
                    if (res.headers.pagination){
                        const pagination= JSON.parse(res.headers.pagination)
                        var params = {
                            paginaActual: pagination.currentPage,
                            registrosPorPagina: pagination.itemsPerPage,
                            totalRegistros: pagination.totalItems,
                            totalPaginas: pagination.totalPages,
                        }    
                        commit('SET_PAGINATION', params);
                    }

                    commit('SET_INDICADORES', res.data);
                    resolve();
                })
                .catch(error => reject(helpers.methods.getErrorMessage(error)));
        })            
    },
};

export default {
    namespaced: true,
    state,
    mutations,
    actions,
    getters
}